import { cn } from '../../../shared/lib/utils'
import React from 'react'

type FormCardProps = {
    children: React.ReactNode,
    className?: string,
}

function FormCard(props: FormCardProps) {
    return (
        <div className={cn('border border-input rounded p-4', props.className)}>
            {props.children}
        </div>
    )
}

export default FormCard